// SVG paths for animated logo segments - Capital Q Shape based on Figma design
const svgPaths = {
  // Top segment - top arc of Q circle
  p185a8e00: "M45.8207 22.9117H68.706L68.7324 22.9381V22.9117H68.7376L68.7324 22.9064L68.7165 0.00527827H45.7996L45.7943 0V0.00527827H22.8721L22.909 0.0369157L22.8984 22.9117H45.8207L45.7838 22.8748Z",
  
  // Right side segment - right curve of Q
  p1d614000: "M45.8207 91.6512H68.7007L68.7324 91.6828V91.6512H68.7376L68.7324 91.6459L68.7165 68.7448H45.7943V68.7395V68.7448H22.8721L22.909 68.7817L22.8984 91.6512H45.8207L45.7838 91.6143Z",
  
  // Bottom-right segment - bottom right and tail of Q
  pebb2d80: "M91.6348 68.9539L68.7336 91.6283V91.6335L91.6348 114.308L91.6242 91.6335L91.6348 68.9539Z",
  
  // Left side segment - left curve of Q
  p68df900: "M0 68.9618V22.9064L22.9117 0V91.6573L0 68.9618Z",
  
  // Bottom segment - bottom of Q circle
  p10c6be80: "M91.6453 68.9618V22.9064L68.7336 0V91.6573L91.6453 68.9618Z",
};

export default svgPaths;
